import toggleMenu from '../utils/togglemenu.js';
import minHeaderOnScroll from '../utils/minimizeheaderonscroll.js';
import smScrollOnLinks from '../utils/smoothscrollonlinks.js';
import setupGrayClass from '../utils/togglegrayscaleclass.js';
import setupIsotope from '../utils/setupisotopegrid.js';
import setupSlider from '../utils/setupslider.js';
import wrapIframe from '../utils/wrapiframe.js';
import setupMinPageH from '../utils/setupminpageheight.js';
import initScroll from '../utils/initScroll';

class Controller{

	init(){
		toggleMenu.init();
		smScrollOnLinks.init();
		setupGrayClass.init();
		
		setupSlider.init();
		wrapIframe.init();
		setupMinPageH.init();
	}
	
	loaded(){
		setupIsotope.init();
		initScroll();
	}

	resized(){
		setupMinPageH.init();
	}

	scrolled(){
		minHeaderOnScroll.init();
	}

}

const contr = new Controller();

export default contr;


// WEBPACK FOOTER //
// ./app/themes/nordic-concert-halls/js/init/controller.js